import React, { useEffect, useRef, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Alert from 'react-bootstrap/Alert'
import CargandoDatosLoader from '../components/CargandoDatosLoader'
import { getDataEPagosDDBB } from '../utils/requests'

const ReturnEpagos = () => {
  const [loading, setLoading] = useState(true)
  const [respuesta, setRespuesta] = useState('')
  const [medioPago, setMedioPago] = useState('')
  const [transaccion, setTransaccion] = useState('')
  const [hasPdf, setHasPdf] = useState(false)
  const linkRef = useRef()

  useEffect(() => {
    getDataEPagosDDBB().then(({ status, content }) => {
      if (status === 200) {
        setRespuesta(content.respuesta)
        setMedioPago(content.medioPago)
        setTransaccion(content.transaccion)
        setHasPdf(content.hasPdf)
        setLoading(false)
      } else {
        console.log('error')
      }
    })
  }, [])

  return (
    <div>
      <CargandoDatosLoader cargando={loading}>
        <Row className="container justify-content-center align-items-center my-5 flex-column">
          <Alert variant={'primary'} style={{ textAlign: 'center' }}>
            <Alert.Heading>Aviso</Alert.Heading>
            {medioPago}: {respuesta}
          </Alert>
        </Row>
        <a style={{ display: 'none' }} ref={linkRef} href="/#">
          #
        </a>
        {hasPdf && (
          <Row className="container justify-content-center align-items-center my-5 flex-column">
            <Button
              variant="outline-primary"
              onClick={() =>
                fetch('/ddjj/api/epagos/pdf')
                  .then((res) => res.blob())
                  .then((blob) => {
                    const href = window.URL.createObjectURL(blob)
                    const a = linkRef.current
                    a.download = `${medioPago} - ${transaccion}.pdf`
                    a.href = href
                    a.click()
                    a.href = ''
                  })
                  .catch((err) => console.log(err))
              }
            >
              Descargar Comprobante de Pago
            </Button>
          </Row>
        )}
      </CargandoDatosLoader>
    </div>
  )
}

export default ReturnEpagos
